import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { DevToolsService } from '../services/dev-tools.service';

@Injectable()
export class DevToolsInterceptor implements HttpInterceptor {
  constructor(private devToolsService: DevToolsService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.devToolsService.isDevToolsEnabled()) {
      return next.handle(req);
    }

    const endpoint = this.extractEndpoint(req.url);
    const method = req.method;

    const mockResponse = this.devToolsService.getMockResponse(endpoint, method);
    
    if (mockResponse) {
      console.log(`[Dev Tools] Mocking ${method} ${endpoint}`, mockResponse);
      
      const response = new HttpResponse({
        status: mockResponse.statusCode || 200,
        statusText: this.getStatusText(mockResponse.statusCode || 200),
        body: mockResponse.response,
        headers: req.headers
      });

      return of(response).pipe(
        delay(mockResponse.delay || 0)
      );
    }

    return next.handle(req);
  }

  private extractEndpoint(url: string): string {
    try {
      const urlObj = new URL(url);
      return urlObj.pathname;
    } catch {
      return url;
    }
  }

  private getStatusText(statusCode: number): string {
    const statusTexts: Record<number, string> = {
      200: 'OK',
      201: 'Created',
      204: 'No Content',
      400: 'Bad Request',
      401: 'Unauthorized',
      403: 'Forbidden',
      404: 'Not Found',
      500: 'Internal Server Error',
      502: 'Bad Gateway',
      503: 'Service Unavailable'
    };
    
    return statusTexts[statusCode] || 'Unknown';
  }
} 